import { useMemo } from 'react';
import { productIndexes, CATEGORY_INDEX_MAPPING } from '../../commons/helpers';
const useMobileSearchFiltersTitle = algoliaIndexName => {
  let t0;
  bb0: {
    if (!algoliaIndexName) {
      t0 = "Products";
      break bb0;
    }
    if (productIndexes?.includes(algoliaIndexName) || algoliaIndexName === "products" || algoliaIndexName === CATEGORY_INDEX_MAPPING.products) {
      t0 = "Products";
      break bb0;
    }
    if (algoliaIndexName === "pages" || algoliaIndexName === CATEGORY_INDEX_MAPPING.pages) {
      t0 = "Pages";
      break bb0;
    }
    if (algoliaIndexName === "categories") {
      t0 = "Categories";
      break bb0;
    }
    if (algoliaIndexName === "customer photos" || algoliaIndexName === CATEGORY_INDEX_MAPPING["customer photos"]) {
      t0 = "Customer Photos";
      break bb0;
    }
    if (algoliaIndexName === "reviews" || algoliaIndexName === CATEGORY_INDEX_MAPPING.reviews) {
      t0 = "Reviews";
      break bb0;
    }
    t0 = "Products";
  }
  const mobileSearchFiltersTitle = t0;
  return mobileSearchFiltersTitle;
};
export default useMobileSearchFiltersTitle;